export default function () {
  document.querySelectorAll("[data-menu-toggle]").forEach((toggle) => {
    const menu = document.getElementById(toggle.dataset.menuToggle);

    toggle.addEventListener("click", () => {
      if (menu.classList.contains("hide")) {
        menu.classList.remove("hide");
        setTimeout(() => {
          menu.querySelector(".mobile-menu__popup").classList.add("is-open");
        }, 0);
      } else {
        menu.querySelector(".mobile-menu__popup").classList.remove("is-open");
        setTimeout(() => {
          menu.classList.add("hide");
        }, 300);
      }
    });
  });
}
